import React from "react";
import settingable from "fantastic/components/hoc/settingable";

const DividerSettings = () => {
  return null;
};

export default settingable("background-color", "visibility")(DividerSettings);
